import React, { useState } from 'react';
import DS_Map from 'mui/components/elements/DS_Map/DS_Map';
import Loader from '../../../../../../components/Booking-new/modules/Steps/shared/Loader';
import { StyledMapLoaderWrapper, StyledMapWrapper } from './styles';

const DS_SingleLocationMap = ({ location }) => {
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const mapOptions = {
    woosmapConfig: {
      zoom: 15,
    },
    hideMarkers: process.env.GATSBY_COUNTRY_CODE === 'de-AT',
    zoomControls: false,
    mapPaddings: {
      mobile: { left: 50, right: 50, top: 50, bottom: 50 },
      full: { left: 1050, right: 50, top: 50, bottom: 50 },
    },
  };

  return (
    <StyledMapWrapper>
      {!isMapLoaded && (
        <StyledMapLoaderWrapper>
          <Loader />
        </StyledMapLoaderWrapper>
      )}
      <DS_Map locations={[location]} setIsMapLoaded={setIsMapLoaded} options={mapOptions}></DS_Map>
    </StyledMapWrapper>
  );
};

export default DS_SingleLocationMap;
